import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, Headers, RequestOptions } from '@angular/http';
import {EnvDataService} from '../../app/services/env-data-service';
@Component({
  selector: 'page-broker_setting',
  templateUrl: 'broker_setting.html',
  providers:[EnvDataService]
})
export class BrokerSettingPage {
  brokerSettingForm: FormGroup;
  public form_name: any;
  public uid: any;
  public firstname: any;
  public lastname: any;
  public email: any;
  //public mercuryApiKey: any;
  public mercurySeurityToken: any;
  public mercuryAgentCode: any;
  public activeCampaignKey: any;
  public getRole: any;
  public getemail = window.localStorage.getItem("email");
  public userRole : any;
  public mobile_phone : any;
  public validation_messages = {
    'firstname': [
        { type: 'required', message: 'Firstname is required.' }
    ],
    'lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'mobile_phone': [
      { type: 'required', message: 'Mobile_phone is required.' }
    ],
    'mercurySeurityToken': [
      { type: 'required', message: 'Mercury Seurity Token is required.' }
    ],
    'mercuryAgentCode': [
      { type: 'required', message: 'Mercury Agent Code is required.' }
    ]
  }

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    private EnvDataService:EnvDataService
  ) {

    let thiss = this;
    thiss.uid = window.localStorage.getItem("uid");
    thiss.userRole = window.localStorage.getItem("userRole");
    var docRef0 = firebase.firestore().collection("users").doc(thiss.uid);
    docRef0.get().then(function(doc) {
      if (doc.exists) {
        let user_data = doc.data();
        thiss.firstname = user_data.firstname;
        thiss.lastname = user_data.lastname;
        thiss.mobile_phone = user_data.mobile_phone;       
      } else {
        console.log("No such document!");
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });

    var docRef1 = firebase.firestore().collection("brokerCredentials").doc(thiss.uid);
    docRef1.get().then(function(doc) {
      if (doc.exists) {
        let user_data = doc.data();
        thiss.mercurySeurityToken = user_data.mercurySeurityToken;        
        thiss.mercuryAgentCode = user_data.mercuryAgentCode;  
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });

    this.form_name = "eLINK Finance";
    this.brokerSettingForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30)])],
      mobile_phone: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: [''],
      //mercuryApiKey: ['', Validators.compose([Validators.maxLength(100)])],
      mercurySeurityToken: ['', Validators.compose([Validators.maxLength(100)])],
      mercuryAgentCode: ['', Validators.compose([Validators.maxLength(100)])]
    });    
  }

  isFieldValid(field: string) {
    return !this.brokerSettingForm.get(field).valid && this.brokerSettingForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  save_setting(){
    if(!this.brokerSettingForm.valid){
      this.brokerSettingForm.get('firstname').markAsDirty();
      this.brokerSettingForm.get('firstname').markAsTouched();

      this.brokerSettingForm.get('lastname').markAsDirty();
      this.brokerSettingForm.get('lastname').markAsTouched();

      this.brokerSettingForm.get('mobile_phone').markAsDirty();
      this.brokerSettingForm.get('mobile_phone').markAsTouched();

      this.brokerSettingForm.get('mercurySeurityToken').markAsDirty();
      this.brokerSettingForm.get('mercurySeurityToken').markAsTouched();

      this.brokerSettingForm.get('mercuryAgentCode').markAsDirty();
      this.brokerSettingForm.get('mercuryAgentCode').markAsTouched();
    }else{
      let uid = window.localStorage.getItem("uid");
      let firstname = this.brokerSettingForm.value.firstname;
      let lastname = this.brokerSettingForm.value.lastname;
      let mobile_phone = this.brokerSettingForm.value.mobile_phone;
      let password = this.brokerSettingForm.value.password;
      //let mercuryApiKey = this.brokerSettingForm.value.mercuryApiKey;
      let mercurySeurityToken = this.brokerSettingForm.value.mercurySeurityToken;
      let mercuryAgentCode = this.brokerSettingForm.value.mercuryAgentCode;
      console.log(password);
      console.log('password');
      if(uid != null){
        this.loadingProvider.startLoading();
        let thiss = this;
        if(password != "" || thiss.mobile_phone != mobile_phone){
          console.log('test1');
          var headers = new Headers();
          headers.append("Accept", 'application/json');
          headers.append('Content-Type', 'application/json' );
          const requestOptions = new RequestOptions({ headers: headers });
          let postData = {
            "uid": uid,
            "phoneNumber": "+6"+mobile_phone,
            "password": password,
            "firstname": firstname,
            "lastname": lastname,
            "mobile_phone": mobile_phone,
            "mercurySeurityToken" : mercurySeurityToken,
            "mercuryAgentCode" : mercuryAgentCode
          }
          console.log(postData);
          var url = this.EnvDataService.EnvData.sendbox_api+"/updateSettings";
          this.http.post(url, postData, requestOptions)
          .subscribe(data => {
            console.log(data['_body']);
            if(data['_body'] == 'The email address is already in use by another account.'){
              this.loadingProvider.stopLoading();  
              this.presentToastSuccess(data['_body']);          
            }else if(data['_body'] == 'The user with the provided phone number already exists.'){
              this.loadingProvider.stopLoading();
              this.presentToastSuccess(data['_body']);
            }else if(data['_body'] == 'TOO_LONG'){
              this.loadingProvider.stopLoading();
              this.presentToastSuccess('Invalid Phone Number.');
            }else if(data['_body'] == 'TOO_SHORT'){
              this.loadingProvider.stopLoading();
              this.presentToastSuccess('Invalid Phone Number.');
            }else if(data['_body'] == 'Invalid format.'){
              this.loadingProvider.stopLoading();
              this.presentToastSuccess('Invalid Phone Number.');
            }else if(data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.'){
              this.loadingProvider.stopLoading();
              this.presentToastSuccess('Invalid Phone Number.');
            }else{
              this.loadingProvider.stopLoading();
              this.presentToastSuccess('Update Broker Credentials successfully!');  
            }
          }, error => {
            this.loadingProvider.stopLoading();
            this.presentToastmsg(error);
          });
        }else{
          console.log('test2');
          let docRef0 = thiss.afs.collection("/users");
          let docRef1 = firebase.firestore().collection("users").doc(uid);
          docRef1.get().then(function(thisDoc) {
            if (thisDoc.exists) {
              docRef0.doc(uid).update({
                firstname: firstname,
                lastname: lastname,
                mobile_phone: mobile_phone,
                password: password
              }).then(function() {
                let docRef2 = thiss.afs.collection("/brokerCredentials");
                let docRef3 = firebase.firestore().collection("brokerCredentials").doc(uid);
                docRef3.get().then(function(thisDoc) {
                  if (thisDoc.exists) {
                    docRef2.doc(uid).update({
                      //mercuryApiKey: mercuryApiKey,
                      mercurySeurityToken: mercurySeurityToken,
                      mercuryAgentCode: mercuryAgentCode
                    }).then(function() {
                      thiss.loadingProvider.stopLoading();
                      thiss.presentToastSuccess("Update Broker Credentials successfully!");
                      console.log("Update Broker Credentials successfully!");
                    }).catch(function(error) {
                      thiss.loadingProvider.stopLoading();
                      thiss.presentToastmsg(error);
                      console.error("Error Update Broker Credentials: ", error);
                    }); 
                  }else{
                    docRef2.doc(uid).set({
                      //mercuryApiKey: mercuryApiKey,
                      mercurySeurityToken: mercurySeurityToken,
                      mercuryAgentCode: mercuryAgentCode
                    }).then(function() {
                      thiss.loadingProvider.stopLoading();
                      thiss.presentToastSuccess("Update Broker Credentials successfully!");
                      console.log("Update Broker Credentials successfully!");
                    }).catch(function(error) {
                      thiss.loadingProvider.stopLoading();
                      thiss.presentToastmsg(error);
                      console.error("Error Update Broker Credentials: ", error);
                    }); 
                  }
                });   
              }).catch(function(error) {
                thiss.loadingProvider.stopLoading();
                thiss.presentToastmsg(error);
                console.error("Error Update Broker Credentials: ", error);
              }); 
            }
          });
        }
      }
    }
  }
  presentToastmsg(err) {
    const toast = this.toastCtrl.create({
      message: err.message,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }
  presentToastSuccess(success) {
    const toast = this.toastCtrl.create({
      message: success,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/broker_setting/broker_setting.ts